import { render, staticRenderFns } from "./classAccess.vue?vue&type=template&id=0ef41db3&"
import script from "./classAccess.vue?vue&type=script&lang=js&"
export * from "./classAccess.vue?vue&type=script&lang=js&"
import style0 from "./classAccess.vue?vue&type=style&index=0&id=0ef41db3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports